import React, {useRef, useState} from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import * as Yup from "yup";
import { useForm} from "react-hook-form";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import Switch from "react-bootstrap-switch";

// components
import FiltersMapLangs from "./_langs";
import Separator from "../../../components/Separator";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

// labels
import { FORM, INTERNATIONAL, REQUIRED} from "../../../components/i18n/i18n";
import { TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE } from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem, setViewMode} from "../../../redux/actions/generics/IndexedActions";

// services & providers
import {categoryProvider} from "../../../providers/categoryProvider";
import {filtersMapProvider} from "../../../providers/filtersMapProvider";
import {typeServicesProvider} from "../../../providers/typeServicesProvider";
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import {paramSettingsProvider} from "../../../providers/paramSettingsProvider";
import {typeFiltersMapProvider} from "../../../providers/typeFiltersMapProvider";
import {filtersMapService} from "../../../jwt/_services/clasificator/filtersMapService";

const FiltersMapForm = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject} = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [translatableLangs ] = useState(domainObject?.translatableLangs || []);
    const [filterNode, setFilterNode] = useState(domainObject?.filterNode || null);
    const [typeFiltersMapId, setTypeFiltersMapId] = useState(domainObject?.type || null);

    const [parentId, setParentId] = useState(domainObject?.parent?.id || null);
    const [typeId, setTypeId] = useState(domainObject?.typeServices?.id || null);
    const [categoryId, setCategoryId] = useState(domainObject?.category?.id || null);
    const [categoryAuxId, setCategoryAuxId] = useState(domainObject?.categoryAux?.id || null);


    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `filter_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE

            showOrder: domainObject?.showOrder,
            description: domainObject?.description,
            icon: domainObject?.icon
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                udn : { id : udn?.id },
                status: status,
                filterNode: filterNode,

                langs: langs,
            }
        }

        if (parentId !== undefined && parentId !== null )
            dataRequest.item.parent = { id : parentId };
        else
            dataRequest.item.parent = null;

        if (typeFiltersMapId !== undefined && typeFiltersMapId !== null )
            dataRequest.item.type = typeFiltersMapId;
        else
            dataRequest.item.type = null;

        if (typeId !== undefined && typeId !== null )
            dataRequest.item.typeServices = typeId;
        else
            dataRequest.item.typeServices = null;

        if (categoryId !== undefined && categoryId !== null )
            dataRequest.item.category = categoryId;
        else
            dataRequest.item.category = null;

        if (categoryAuxId !== undefined && categoryAuxId !== null )
            dataRequest.item.categoryAux = categoryAuxId;
        else
            dataRequest.item.categoryAux = null;

        // console.log(dataRequest);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, filtersMapService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, filtersMapService, dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    const notImplementedAction = () => {
        console.log('sin implementar');
    }

    const formHotel = () => {
        return (
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{'Codigo'}</Label>
                        <Input type="text"
                               name="code"
                               placeholder="Ingrese codigo"
                               innerRef={register}
                               className={(errors.code ? ' is-invalid' : '')}
                        />
                        { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{'Icono'}</Label>
                        <Input type="text"
                               name="icon"
                               placeholder="Ingrese icono"
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Orden</Label>
                        <br/>
                        <Input type="number" name="showOrder"
                               placeholder="Orden"
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{'Activo'}</Label>
                        <br/>
                        <Switch animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={_ => setStatus(!status)}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{'Filtro padre'}</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={parentId}
                            setExternalValue={setParentId}
                            provider={filtersMapProvider}
                            // customFilter={ { udn : { id : udn.id } } }
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label htmlFor="type">Tipo de filtro</Label>
                        <SelectGeneric
                            initialValue={ typeFiltersMapId }
                            setExternalValue={ setTypeFiltersMapId }
                            provider = { typeFiltersMapProvider }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{'Categoria'}</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={categoryId}
                            setExternalValue={setCategoryId}
                            provider={hotelCategoryProvider}
                        />
                    </FormGroup>
                </Col>
            </Row>
            // <Card className={"form_data"}>
            //     <CardTitle className="bg-light border-bottom p-3 mb-0">
            //         <i className="far fa-edit mr-2"/>{FORM}
            //     </CardTitle>
            //     <CardBody>
            //
            //     </CardBody>
            // </Card>
        )
    }

    const formPark = () => {
        return (
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Codigo'}</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder="Ingrese codigo"
                                   innerRef={register}
                                   className={(errors.code ? ' is-invalid' : '')}
                            />
                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'Icono'}</Label>
                            <Input type="text"
                                   name="icon"
                                   placeholder="Ingrese icono"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label htmlFor="type">Tipo de filtro</Label>
                            <SelectGeneric
                                initialValue={ typeFiltersMapId }
                                setExternalValue={ setTypeFiltersMapId }
                                provider = { typeFiltersMapProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Orden</Label>
                            <br/>
                            <Input type="number" name="showOrder"
                                   placeholder="Orden"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Activo'}</Label>
                            <br/>
                            <Switch animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
        )
    }

    const formEvents = () => {
        return (
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{'Codigo'}</Label>
                        <Input type="text"
                               name="code"
                               placeholder="Ingrese codigo"
                               innerRef={register}
                               className={(errors.code ? ' is-invalid' : '')}
                        />
                        { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                    </FormGroup>
                </Col>

                <Col md="3">
                    <FormGroup>
                        <Label>{'Icono'}</Label>
                        <Input type="text"
                               name="icon"
                               placeholder="Ingrese icono"
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Orden</Label>
                        <br/>
                        <Input type="number" name="showOrder"
                               placeholder="Orden"
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{'Activo'}</Label>
                        <br/>
                        <Switch animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={_ => setStatus(!status)}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{'Filtro padre'}</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={parentId}
                            setExternalValue={setParentId}
                            provider={filtersMapProvider}
                            // customFilter={ { udn : { id : udn.id } } }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{'Tipo de servicio'}</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={typeId}
                            setExternalValue={setTypeId}
                            provider={typeServicesProvider}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label htmlFor="type">Tipo de filtro</Label>
                        <SelectGeneric
                            initialValue={ typeFiltersMapId }
                            setExternalValue={ setTypeFiltersMapId }
                            provider = { typeFiltersMapProvider }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{'Categoria'}</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={categoryAuxId}
                            setExternalValue={setCategoryAuxId}
                            provider={categoryProvider}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{'Nodo de datos'}</Label>
                        <br/>
                        <SelectGeneric
                            initialValue={filterNode}
                            setExternalValue={setFilterNode}
                            customFilter={{ item : {ps_key: 'xkynet_config_service_nodes'}} }
                            provider={paramSettingsProvider}
                        />
                    </FormGroup>
                </Col>
            </Row>
            // <Card className={"form_data"}>
            //     <CardTitle className="bg-light border-bottom p-3 mb-0">
            //         <i className="far fa-edit mr-2"/>{FORM}
            //     </CardTitle>
            //     <CardBody>
            //
            //     </CardBody>
            // </Card>
        )
    }

    const getInternational = () => {
        return (
            <>
                <CardBody>
                     <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="far fa-edit mr-2"/>{INTERNATIONAL}
                     </CardTitle>
                    <FiltersMapLangs langs={langs} setLangs={setLangs} translatableLangs={translatableLangs} />
                </CardBody>
            </>
            // <Card className={"form_data"}>
            // <CardBody>
            //     <CardTitle className="bg-light border-bottom p-3 mb-0">
            //         <i className="far fa-edit mr-2"/>{INTERNATIONAL}
            //     </CardTitle>
            //     <FiltersMapLangs langs={langs} setLangs={setLangs} translatableLangs={translatableLangs} />
            // </CardBody>
            // </Card>
        )
    }

    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={ 'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <Separator/>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={filtersMapService} path={path} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_DELETE}
                                    icon={'fa-trash'}
                                    permission={'delete'}
                                    onClick={notImplementedAction}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        {(
                            function() {
                                switch (app.code) {
                                    case "PARK" :
                                        return formPark();
                                    case "EVENTS" :
                                        return formEvents();
                                    default:
                                        return formHotel();
                                }
                            })()}
                    </Row>
                    <Row>
                        { getInternational() }
                    </Row>
                </CardBody>
            </Card>
        </Form>

        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setViewMode,
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(FiltersMapForm)